import refnext from "assets/logos/refnext.png";
import { getItem } from "./session";
const authToken = getItem("token");

export const configData = {
    logo: refnext,
    APP_NAME: "Refnext",
    country: 'in',
    authorization: authToken ? { 'Authorization': `Bearer ${authToken}` } : null,
    countryCode: "+91-",
    contactNumberLength: 10,
    maxContactLength: 13
}

export const userWiseRoleId = {
    superAdmin: 1,
    dealer: 6,
    contractor: 7,
    processer: 8,
    refrigerantManufacturer: 9,
    transportContractor: 10,
    fieldEngineer: 11,
    customer: 12,
    processEngineer: 13,
    dealerUser: 16,
    building: "building",
    admin: 17,
    productManufacture: 18,
    productManufactureUser: 19,
    salesDepartment: 20,
    salesOffice: 5,
    salesDepartmentUser: 21,
    salesOfficeUser: 22,
}

const {
    admin,
    superAdmin,
    dealer,
    contractor,
    processer,
    refrigerantManufacturer,
    transportContractor,
    fieldEngineer,
    customer,
    processEngineer,
    dealerUser,
    building,
    productManufacture,
    productManufactureUser,
    salesDepartment,
    salesOffice,
    salesDepartmentUser,
    salesOfficeUser
} = userWiseRoleId

const ADMIN = admin
const SUPER_ADMIN = superAdmin
const DEALER = dealer
const DEALER_USER = dealerUser
const CONTRACTOR = contractor
const FIELD_ENGINEER = fieldEngineer
const PROCESSER = processer
const PROCESS_ENGINEER = processEngineer
const REFRIGERANT_MANUFACTURER = refrigerantManufacturer
const TRANSPORT_CONTRACTOR = transportContractor
const CUSTOMER = customer
const BUILDING = building
const PRODUCT_MANUFACTURER = productManufacture
const PRODUCT_MANUFACTURER_USER = productManufactureUser
const SALES_DEPARTMENT = salesDepartment
const SALES_OFFICE = salesOffice
const SALES_DEPARTMENT_USER = salesDepartmentUser
const SALES_OFFICE_USER = salesOfficeUser

const allUsers = [
    admin,
    superAdmin,
    dealer,
    contractor,
    processer,
    refrigerantManufacturer,
    transportContractor,
    fieldEngineer,
    customer,
    processEngineer,
    dealerUser,
    building,
    productManufacture,
    productManufactureUser,
    salesDepartment,
    salesOffice,
    salesDepartmentUser,
    salesOfficeUser
]

const CHILD_USERS = [FIELD_ENGINEER, PROCESS_ENGINEER, DEALER_USER, PRODUCT_MANUFACTURER_USER, SALES_DEPARTMENT_USER, SALES_OFFICE_USER];
const CHILD_USERS_ENTITY = ["FIELD_ENGINEER", "RECYCLE_ENGINEER", "DEALER_USER", "PRODUCT_MANUFACTURER_USER", "SALES_DEPARTMENT_USER", "SALES_OFFICE_USER"];
export {
    allUsers,
    ADMIN,
    SUPER_ADMIN,
    DEALER,
    CONTRACTOR,
    PROCESSER,
    REFRIGERANT_MANUFACTURER,
    TRANSPORT_CONTRACTOR,
    FIELD_ENGINEER,
    CUSTOMER,
    PROCESS_ENGINEER,
    DEALER_USER,
    BUILDING,
    PRODUCT_MANUFACTURER,
    PRODUCT_MANUFACTURER_USER,
    SALES_DEPARTMENT,
    SALES_OFFICE,
    SALES_DEPARTMENT_USER,
    SALES_OFFICE_USER,
    CHILD_USERS,
    CHILD_USERS_ENTITY
}
